/**
 * AvvisoMantra — attribuzione della modalità Mantra (Andrea 2026-09-17).
 *
 * Mantra non e' nostro: e' un sistema di gioco ideato e creato da
 * Fantacalcio.it. Lo si dice dove la modalità si sceglie (crea lega, crea
 * stagione) e nelle Regole, quando la stagione e' Mantra.
 */

import { NOMENCLATURA_PRO } from "./nomenclatura";
import { tr } from "../../i18n";

export function AvvisoMantra({ className = "" }: { className?: string }) {
  // Andrea 2026-09-29: la modalità si chiama Pro, con ruoli e nomi nostri;
  // l'attribuzione vale solo con la nomenclatura originale.
  if (NOMENCLATURA_PRO) return null;
  return (
    <div
      role="note"
      className={`rounded-card border border-info/30 bg-info/10 px-3 py-2 text-[11px] leading-snug text-fg-muted ${className}`}
    >
      <span className="text-info font-bold">{tr("ℹ Modalità Mantra")}</span> — il sistema Mantra
      (ruoli, moduli e schieramenti) è ideato e creato da{" "}
      <span className="text-fg font-bold">Fantacalcio.it</span>
      {tr(
        tr(
          ", a cui appartengono nome e diritti. FantaSquad lo adotta come modalità di gioco e non è affiliata né sponsorizzata da Fantacalcio.it.",
        ),
      )}
    </div>
  );
}
